const icons: { [key: string]: string } = {
  heart: 'fi-heart',
  home: 'fi-house-chimney',
  infosquare: 'fi-square-info',
  location: 'fi-marker',
  lock: 'fi-lock',
  login: 'fi-sign-in-alt',
  logout: 'fi-sign-out-alt',
  message: 'fi-envelope',
  plus: 'fi-square-plus',
  profile: 'fi-user',
  search: 'fi-search',
  send: 'fi-paper-plane',
  shielddone: 'fi-shield-check',
  shieldfail: 'fi-shield-exclamation',
  ticket: 'fi-ticket',
  ticketstar: 'fi-ticket',
  timecircle: 'fi-clock',
  speed: 'fi-tachometer-fast',
  calendardone: 'fi-calendar-check',
  'done-bold': 'fi-check',
  'fail-bold': 'fi-cross-small'
};

export default function(iconName: string) {
  if (Object.keys(icons).includes(iconName)) {
    iconName = icons[iconName];
  }
  if (iconName.startsWith('fi-')) {
    return {
      cls: 'fi fi-rr-' + iconName.replace('fi-', ''),
      brand: 'fi fi-brands-' + iconName.replace('fi-', '')
    };
  }

  return { icon: iconName };
}
